import React, { useState } from "react"
import {
    Button,
    Content,
    Dialog,
    DialogTrigger,
    Flex,
    Heading,
    Text,
} from "@adobe/react-spectrum"

const DefaultTemplate = ({ templateData }) => {
    const [isOpen, setIsOpen] = useState(false)
    // const lines = templateData?.body?.split("\n").filter(Boolean)
    // const openingStatement = lines.length > 0 ? lines[0] : ""
    // const closingStatement = lines.length > 1 ? lines[lines.length - 1] : ""
    // const caseData = lines.slice(1, lines.length - 1)

    function getOpeningClosingAndAttributes(string) {
        const lines = string?.split(/\r?\n/)?.map(line => line.trim()).filter(line => line !== "");
        const fieldPattern = /^[\w\s]+:\s*\{.*\}$/;

          let opening = [];
          let mid = [];
          let closing = [];
        
          let phase = "opening";
        
          for (let i = 0; i < lines?.length; i++) {
            const line = lines[i];
        
            if (phase === "opening" && fieldPattern.test(line)) {
              phase = "mid";
            }
        
            if (phase === "mid" && !fieldPattern.test(line)) {
              phase = "closing";
            }
        
            if (phase === "opening") {
              opening.push(line);
            } else if (phase === "mid") {
              mid.push(line);
            } else {
              closing.push(line);
            }
          }
        //   console.log("OPENING: \n", opening.join("\n"));
        //   console.log("MID: \n", mid);
        //   console.log("CLOSING: \n", closing.join("\n"));

          const openingStatement = opening.join("\n")
          const midStatement = mid
          const closingStatement = closing.join("\n")

          return { openingStatement, midStatement, closingStatement }
    }

    const { openingStatement, midStatement, closingStatement } = getOpeningClosingAndAttributes(templateData?.body)

    return (
        <Flex backgroundColor="gray-800">
            <DialogTrigger isOpen={isOpen} onOpenChange={setIsOpen}>
                <Button variant="primary">View Default Template</Button>
                <Dialog>
                    <Heading>Default Template</Heading>
                    <Content>
                        <Text>
                            <strong>Subject: </strong>
                            {templateData?.subject}
                        </Text>
                        <br />
                        <br />
                        <Text>
                            {/* <strong>Opening Statement: </strong> */}
                            {openingStatement}
                        </Text>
                        <Flex
                            direction="column"
                            gap="size-100"
                            marginTop="size-200"
                        >
                            {midStatement?.map((line, index) => {
                                const [label, ...rest] = line.split(":")
                                const value = rest.join(":")

                                return (
                                    <Text key={index}>
                                        <strong>{label}:</strong> {value}
                                    </Text>
                                )
                            })}
                        </Flex>
                        <Text marginTop="size-200">
                            {/* <strong>Closing Statement: </strong> */}
                            {closingStatement}
                        </Text>
                    </Content>
                    <Button
                        variant="secondary"
                        slot="footer"
                        marginTop="size-200"
                        onPress={() => setIsOpen(false)}
                    >
                        Close
                    </Button>
                </Dialog>
            </DialogTrigger>
        </Flex>
    )
}

export default DefaultTemplate
